(ns storrito.editor-load.migrate
  (:require [storrito.instagram.story.post.util :as pu]
            [clojure.walk :as walk]
            ))

;; Concept:
;;
;; The FabricJS model of the story editor was changed several times,
;; this namespace takes care that the loaded FabricJS model is
;; migrated to the latest schema.

(defn remove-layer-idx
  [canvas-object-map]
  (into
    {}
    (map
      (fn [[object-id object]]
        [object-id (dissoc object :layer-idx)])
      canvas-object-map)))

(defn layer-index-of-type
  "Standard layer if `:layer-idx` is not set."
  [object]
  (let [id (:id object)
        type (:type object)]
    (or
      (get
        {"location-sticker" 10001
         "poll-sticker" 10001
         "poll-sticker-v2" 10001
         "slider-sticker" 10001
         "question-sticker" 10001
         "quiz-sticker" 10001
         "countdown-sticker" 10001}
        id)
      (get
        {"text" 10000
         "rect" 9999
         "image" 9998}
        type))))

(def fixed-layers
  ["background"
   "main-image"
   "main-video"])

(defn sort-order
  [canvas-object-map]
  (map
   :id
   (sort-by
    (fn [canvas-object]
      (or
       (:layer-idx canvas-object)
       (layer-index-of-type canvas-object)))
    (vals
     (apply dissoc
            canvas-object-map
            fixed-layers)))))

(defn is-usertag-object? [v]
  (and (= (:type v) "i-text")
    (pu/usertag-object? v)
    (:editable v)))

(defn change-usertag-editable [e]
  (into {} (map
             (fn [[k v]]
               (if (is-usertag-object? v)
                 [k (assoc v :editable false)]
                 [k v])))
    e))

(defn change-text-to-itext [e]
  (into {} (map
             (fn [[k v]]
               (if (= (:type v) "text")
                 [k (assoc v :type "i-text")]
                 [k v])))
    e))

(defn unlock-movement
  [e]
  (into {} (map
             (fn [[k v]]
               (if (= (:id v) "background")
                 [k v]
                 [k (assoc v :lockMovementY false
                             :lockMovementX false
                             :selectable true)])))
        e))

(defn make-cross-origin-anonymous
  "Sets `:crossOrigin` to 'anonymous' for all FabricJS objects that has such an entry.

   In combination with an appropriate CORS header error like the following can
   be avoided:

   Uncaught SecurityError: Failed to execute 'getImageData' on 'CanvasRenderingContext2D': The canvas has been tainted by cross-origin data.

   Where we for example moved a customer to a different subdomain, while still
   absolute URLs of the old subdomain are used in the `fabricjs-model`."
  [x]
  (if (contains? x
                 :crossOrigin)
    (assoc x
           :crossOrigin
           "anonymous")
    x))

(defn walk
  [fabricjs-model]
  (walk/postwalk
    (fn [x]
      (make-cross-origin-anonymous x)
      )
    fabricjs-model))

(defn migrate-fabricjs-model
  [fabricjs-model]
  (when (seq fabricjs-model) ;; do not migrate an empty fabricjs-model
    (-> fabricjs-model
        (update :objects dissoc "storrito-tag")
        (update :objects remove-layer-idx)
        (update :order (fn [order]
                         (or order
                             (sort-order (:objects fabricjs-model)))))
        (update :objects change-text-to-itext)
        (update :objects unlock-movement)
        (update :objects change-usertag-editable)
        (walk)
        )))
